import type { ReactNode } from "react";
import { clsx } from "../../utils/clsx";
import * as styles from "./Section.css";

type SectionProps = {
  children: ReactNode;
  tone?: "default" | "alt" | "dark";
  compact?: boolean;
  className?: string;
};

export function Section({
  children,
  tone = "default",
  compact = false,
  className
}: SectionProps) {
  return (
    <section
      className={clsx(
        styles.section,
        compact && styles.compact,
        tone === "alt" && styles.alt,
        tone === "dark" && styles.dark,
        className
      )}
    >
      {children}
    </section>
  );
}
